import { usePrint } from '@abyss/web/hooks/usePrint';
import { globalCss } from '@abyss/web/tools/styled';

import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { useFeatureFlag } from '../useFeatureFlag';

const printGlobalStyles = globalCss({
  '@media print': {
    '#global-header': {
      display: 'none',
    },
    '#global-main': {
      display: 'none',
    },
    '#global-footer': {
      display: 'none',
    },
    '[class*="abyss-toast"]': {
      display: 'none !important',
    },
  },
});

export const usePrintPSX = () => {
  const [enablePSXPrintSolution] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PSX_PRINT,
  ]);
  const print = usePrint();
  const printPSXPage = () => {
    if (enablePSXPrintSolution) {
      printGlobalStyles();
      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );
      if (isSafari) {
         const originalOpen = window.open.bind(window);
        (window as any).open = function (
          ...args: Parameters<typeof window.open>
        ) {
          const newWin = originalOpen(...args);
          (window as any).open = originalOpen;
          if (newWin) {
            try {
              newWin.document.write(
                `<!DOCTYPE html><html><head><meta name="viewport" content="width=${
                  window.innerWidth || 1200
                },initial-scale=1"></head><body></body></html>`
              );
              newWin.document.close();
            } catch  {
              /* cross-origin guard */
            }
          }
          return newWin;
        };
        print.printPage(() => {}, { openNewWindow: true,});
      } else {
        print.printPage();
      }
    } else {
      print.printPage(() => {}, {
        openNewWindow: false,
      });
    }
  };
  return { printPSXPage };
};
